import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const MaterialPreview = lazy(() => import('../components/MaterialPreview').then(m => ({
  default: m.MaterialPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-267">
      <div data-id="element-268">
        <HeroSection data-id="element-269" />

        <Suspense fallback={null} data-id="element-270">
          <TrustBar data-id="element-271" />
          <ContrastSection data-id="element-272" />
          <ForWhomSection data-id="element-273" />
          <BenefitsSection data-id="element-274" />
          <ContentPreview data-id="element-275" />
          <MaterialPreview data-id="element-276" />
          <BonusSection data-id="element-277" />
          <PricingSection data-id="element-278" />
        </Suspense>

        <Suspense fallback={null} data-id="element-279">
          <GuaranteeSection data-id="element-280" />
          <TestimonialsSection data-id="element-281" />
          <FAQSection data-id="element-282" />
          <Footer data-id="element-283" />
          <SocialProofPopup data-id="element-284" />
        </Suspense>
      </div>
    </main>;
}